var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LiveData',{staticClass:"liveData",attrs:{"liveData":_vm.dayRainData}}),_c('LiveData',{staticClass:"liveData",attrs:{"liveData":_vm.monthRainData}}),_c('LiveData',{staticClass:"liveData",attrs:{"liveData":_vm.yearRainData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }